import styled from 'styled-components';
import H6 from 'sushiweb/Typography/Heading/H6';
import { P } from 'sushiweb/Typography/Text';
import Button from 'sushiweb/Button/Button';
import grey from 'sushiweb/tokens/color/grey';

export const UploadZone = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100px;
  border: 1.5px dashed ${({ disabled }) => (disabled ? '#ccc' : '#e02020')};
  border-radius: 8px;
  background: ${({ disabled }) => (disabled ? '#f9f9f9' : '#fff5f5')};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  margin: 1.5rem 0 0.5rem;
  position: relative;
  overflow: hidden;
`;

export const HiddenInput = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
`;

export const ZoneText = styled(H6)`
  color: ${({ disabled }) => (disabled ? '#aaa' : '#e02020')};
  pointer-events: none;
`;

export const InstructionText = styled(P)`
  color: #7a7a7a;
  font-size: 12px;
  margin: 2px 0;
`;

export const FileRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  margin-top: 8px;
  background: #fafafa;
`;

export const FileName = styled(P)`
  flex: 1;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  padding: 2rem 0 1rem;
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  margin-top: 1.5rem;
`;

export const ManageOptionsWrapper = styled.div`
  position: relative;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  overflow: visible;
`;

export const ManageOptionsButton = styled(Button)``;

export const DropdownMenu = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 16px rgba(28, 28, 28, 0.15);
  z-index: 100;
  min-width: 280px;
  overflow: hidden;
`;

export const DropdownItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  cursor: pointer;
  font-size: 14px;
  color: ${grey.z800};
  &:hover {
    background: ${grey.z100};
  }
`;
